import React, {useEffect, useState} from "react";
import './index.css';
// import NavigationBar from "./navBar";
import NavigationBar from "../NavigationBar";
import axios from "axios";
import {useParams} from "react-router-dom";
import services from "../services/services";
import UserReviewList from "../UserReviewList";
import EditProfileComponent from "../EditProfile/EditProfileComponent";
import reviewService from "../services/ReviewService";
import VisitingReviewList from "../UserReviewList/VisitingReviewList";

const VisitingProfile = () => {

    //check if a session is going on
    const[user, setUser] = useState("");
    const[visitUser, setVisitUser] = useState([]);

    //using axios for easy fetching
    useEffect( () => {
        axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin').
        then(response => {

            // Get the complete data about the user.
            if(response.data) {
                setUser(response.data)
            }
        });
    }, []);

    const currUserId = useParams().userId;
    const[allUser, setAllUser] = useState("");

    useEffect(() =>
        services.findUser(currUserId).then(user => setVisitUser(user)), []);

    console.log(visitUser)
    const [reviewList, setReview] = useState([]);
    useEffect(() =>
                  reviewService.findAllUserReviews(visitUser.userId).
                  then(review => setReview(review)), [visitUser.userId]);
    return (
        <>
            <NavigationBar/>
            <EditProfileComponent user={visitUser}/>
            <div className="container mt-1">
                <h2>Recent Reviews</h2>
                <VisitingReviewList userId={visitUser.userId}/>
            </div>
        </>
    )
}

export default VisitingProfile;